import React from 'react';
import { Input } from '@/components/ui/input';
import { Search, X } from 'lucide-react';
import { cn } from '@/lib/utils';

const CommonSearchInput = React.forwardRef(({
  className,
  placeholder = "Search...",
  onSearch,
  value,
  onChange,
  maxLength = 50,
  ...props
}, ref) => {
  const handleInputChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const val = e.target.value;
      if (onSearch) {
        onSearch(val);
      }
    }
  };

  const handleClear = () => {
    if (onSearch) {
      onSearch('');
    }
    if (onChange) {
      onChange({ target: { value: '' } });
    }
  };

  return (
    <div className={cn("relative w-full", className)}>
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 z-10">
        <Search size={18} className="text-muted-foreground/60" />
      </div>
      <Input
        ref={ref}
        type="text"
        placeholder={placeholder}
        value={value || ''}
        maxLength={maxLength}
        className={cn(
          "block w-full border border-input bg-background pl-10 pr-10 text-sm placeholder:text-muted-foreground/40 transition-all focus-visible:ring-primary/20 rounded-lg",
          className
        )}
        style={{ height: '40px', borderRadius: '8px' }}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        {...props}
      />
      {value && value.length > 0 && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground/60 hover:text-foreground transition-colors z-10"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
});

CommonSearchInput.displayName = 'CommonSearchInput';

export { CommonSearchInput };